export class DynamicScript {
  constructor(
    public id: number,
    public url: string,
    public displayName: string,
    public showScriptOnTopRight: boolean,
    public showScriptOnRightClickWithContent: boolean,
    public showScriptOnRightClickWithoutContent: boolean,
  ) {}
}
